export default __webpack_public_path__ + "static/media/us-locale.a4482e8d.svg";